import Api from '../../../misc/api'
import { state } from './state'

export interface RemoteListsPayload {
  url: string
  urlParams?: { [key: string]: string }
}

export interface GetCompletionItemsPayload extends RemoteListsPayload {
  urlParams: {
    search: string
    type: string
    contextDate?: string
  }
  signal: AbortSignal
}

export interface GetBiologyValuesPayload extends RemoteListsPayload {
  urlParams: {
    title: string
  }
}

export const actions = {
  getCompletionItems({ commit }, payload: GetCompletionItemsPayload) {
    return Api.request(
      state.requests.getCompletionItems,
      {
        url: payload.url,
        urlParams: payload.urlParams,
        signal: payload.signal,
        startMut: 'getCompletionItemsStart',
        successMut: 'getCompletionItemsSuccess',
        errorMut: 'getCompletionItemsError',
      },
      commit
    )
  },

  getBiologyValues({ commit }, payload: GetBiologyValuesPayload) {
    return Api.request(
      state.requests.getBiologyValues,
      {
        url: payload.url,
        urlParams: {
          ...payload.urlParams,
          type: 'biologyValues',
        },
        startMut: 'getBiologyValuesStart',
        successMut: 'getBiologyValuesSuccess',
        errorMut: 'getBiologyValuesError',
      },
      commit
    )
  },

  fetchMedicalUnits({ state, commit }, payload: RemoteListsPayload) {
    return Api.request(
      state.requests.fetchMedicalUnits,
      {
        url: payload.url,
        startMut: 'fetchMedicalUnitsStart',
        successMut: 'fetchMedicalUnitsSuccess',
        errorMut: 'fetchMedicalUnitsError',
      },
      commit
    )
  },

  fetchConstants({ commit }, payload: RemoteListsPayload) {
    return Api.request(
      state.requests.fetchConstants,
      {
        url: payload.url,
        startMut: 'fetchConstantsStart',
        successMut: 'fetchConstantsSuccess',
        errorMut: 'fetchConstantsError',
      },
      commit
    )
  },

  fetchNamedEntities({ commit }, payload: RemoteListsPayload) {
    return Api.request(
      state.requests.fetchNamedEntities,
      {
        url: payload.url,
        successMut: 'setNamedEntities',
      },
      commit
    )
  },

  fetchDataPresence({ commit }) {
    return Api.request(
      state.requests.fetchDataPresence,
      {
        startMut: 'fetchDataPresenceStart',
        successMut: 'fetchDataPresenceSuccess',
        errorMut: 'fetchDataPresenceError',
      },
      commit
    )
  }
}
